'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UtilsService = function () {
  function UtilsService($http, $q, appConfig, enums) {
    "ngInject";

    (0, _classCallCheck3.default)(this, UtilsService);
    this.$http = $http;
    this.$q = $q;
    this.appConfig = appConfig;
    this.enums = enums;
  }

  (0, _createClass3.default)(UtilsService, [{
    key: 'calculateAmount',
    value: function calculateAmount(calc) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/utils/calculateAmount', calc);
    }
  }, {
    key: 'calculateMonthly',
    value: function calculateMonthly(calc) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/utils/calculateMonthly', calc);
    }
  }, {
    key: 'calculateTerm',
    value: function calculateTerm(calc) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/utils/calculateTerm', calc);
    }
  }, {
    key: 'calculateRate',
    value: function calculateRate(calc) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/utils/calculateRate', calc);
    }
  }, {
    key: 'getDatePart',
    value: function getDatePart(dateString) {
      if (dateString) {
        var timeIndex = dateString.search(/T/);

        return new Date(dateString.substring(0, timeIndex));
      } else {
        return null;
      }
    }
  }]);
  return UtilsService;
}();

exports.default = UtilsService;


// WEBPACK FOOTER //
// ./client/app/common/services/utilsService.js